/****   mock.js   ****/
// 导入封装好的axios实例
import request from './java-request.js'
import axios from 'axios'
const mockBaseUrl = 'https://console-mock.apipost.cn/app/mock/project'

const mock = {
	/**
	 * methods: 请求
	 * @param url 请求地址
	 * @param params 请求参数
	 */
	get(url, params) {
		const config = {
			method: 'get',
			url: this.getMockUrl(url)
		}
		if (params) config.params = params
		return request(config)
	},
	post(url, params) {
		const config = {
			method: 'post',
			url: this.getMockUrl(url)
		}
		if (params) config.data = params
		return request(config)
	},
	all(arr){
		return axios.all(arr)
	},
	// 文件上传
	upload(url, params) {
		const config = {
			method: 'post',
			url: this.getMockUrl(url)
		}
		config.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
		if (params) config.data = params
		return request(config)
	},
	put(url, params) {
		const config = {
			method: 'put',
			url: this.getMockUrl(url)
		}
		if (params) config.params = params
		return request(config)
	},
	delete(url, params) {
		const config = {
			method: 'delete',
			url: this.getMockUrl(url)
		}
		if (params) config.params = params
		return request(config)
	},
	
	getMockUrl(url){
		let templateList = [{
			oldUrl:'/message-inform',
			newUrl:'/d3672d97-e03f-4f26-e7f6-76b67c15f677'
		},{
			oldUrl:'/plan-plate',
			newUrl:'/bc7286ba-71a1-4bd9-cd7c-4d56e47b1112'
		},{
			oldUrl:'/user-center',
			newUrl:'/b6e4dbfb-d6eb-4258-b8c7-ab70d01d87f2'
		},{
			oldUrl:'/order',
			newUrl:'/9f68e374-1b91-462f-8571-79e385ee9b48'
		}]
		let findIndex = templateList.findIndex((item,index)=>{
			if(url.indexOf(item.oldUrl) != -1){
				return true
			}else{
				return false
			}
		})
		return mockBaseUrl + url.replace(templateList[findIndex].oldUrl,templateList[findIndex].newUrl)
	}
}
//导出
export default mock



// WEBPACK FOOTER //
// ./src/utils/mock.js